/**
 * Reads a `VITE_APP_*` boolean feature flag, treating anything other than `true` as off.
 *
 * Always read flags through this helper instead of comparing `import.meta.env.X === 'true'`
 * inline. The Docker image is built once for every environment: the build bakes a
 * `__VITE_APP_X__` placeholder that `entrypoint.sh` substitutes with the real value when the
 * container starts. An inline comparison becomes `'__VITE_APP_X__' === 'true'` after Vite's
 * substitution — two string literals, which the minifier constant-folds to `false`. That strips
 * the placeholder from the bundle, so `entrypoint.sh` has nothing left to replace and the flag
 * can never be switched on at runtime. The `String()`/`trim()`/`toLowerCase()` calls are opaque
 * to the folder, so the placeholder survives into the built assets.
 *
 * Passing the value in (rather than reading `import.meta.env` here) keeps the helper testable
 * and lets each call site name the variable it depends on.
 *
 * @param value Raw environment value, e.g. `import.meta.env.VITE_APP_AI_ENABLED`.
 * @returns `true` only for the string `true`, case- and whitespace-insensitive.
 */
export function envFlag(value: string | undefined): boolean {
  return String(value).trim().toLowerCase() === 'true';
}
